import { Folder } from '../types/GraphqlTypes';
import getValueFromEnum from './getValueFromEnum';

export default function (folder: string | null): Folder {
  if (folder === 'REPORTED') {
    return Folder.Spam;
  } else {
    return getValueFromEnum(folder, Folder) || Folder.Inbox;
  }
}
